module.exports = __webpack_public_path__ + "img/pjmcc.b93cddb5.jpg";